module.exports = __webpack_public_path__ + "static/media/onboarding-2.2d609c08.png";